import React, { useState } from 'react'
import { Icon, Card, Label, RadioGroup, CriticalRadio, Button } from '../../../atoms'

interface Product {
  name: string
  icon: string
  text: string
  buttonText: string
  href: string
}

interface Props {
  heading: string
  subheading: string
  products: Product[]
  dataClickTracking: Record<string, any>
}

const ProductNavigation = ({ heading, subheading, products, dataClickTracking }: Props) => {
  const [checkedIndex, setCheckedIndex] = useState(0)

  return (
    <div className='ProductNavigation' data-controller='product-navigation'>
      <Card variant='plum'>
        <h2 className='ProductNavigation__title'>{heading}</h2>
        <div className='ProductNavigation__inner-card'>
          <Label>{subheading}</Label>
          <RadioGroup stack={true}>
            {products.map((product, i) => {
              return (
                <CriticalRadio
                  onClick={() => setCheckedIndex(i)}
                  name='product-navigation'
                  centerLabel={true}
                  buttonAlignment={'top-left'}
                  checked={i === checkedIndex}
                  labelTarget={{ 'data-product-navigation-target': 'radioButtonLabel' }}
                  buttonActions={{
                    'data-action': 'click->product-navigation#radioButtonClicked',
                    'data-product-navigation-index-param': i,
                    'data-product-navigation-dataclicktracking-param': JSON.stringify({
                      ...dataClickTracking,
                      additionalProps: {
                        name: product.name,
                        index: i,
                      },
                    }),
                  }}
                >
                  <div className='ProductNavigation__radioButton'>
                    <Icon glyph={product.icon} size={32} color={'#34454E'} />
                    <div className='ProductNavigation__radioButton__text'>
                      <span className='ProductNavigation__radioButton__label'>{product.name}</span>
                    </div>
                  </div>
                </CriticalRadio>
              )
            })}
          </RadioGroup>
        </div>

        {products.map((product) => {
          return (
            <div data-product-navigation-target='text'>
              <div className='ProductNavigation__text'>{product.text}</div>
              <div className='ProductNavigation__cta'>
                <Button
                  href={product.href}
                  withIcon={false}
                  dataClickTracking={{
                    ...dataClickTracking,
                    additionalProps: {
                      name: product.name,
                      buttonText: product.buttonText,
                      href: product.href,
                    },
                  }}
                >
                  {product.buttonText}
                </Button>
              </div>
            </div>
          )
        })}
      </Card>
    </div>
  )
}

export default ProductNavigation
